/**
 * widgetapi serializes Terpli storeID as a JSON number. Coerce before
 * calling string methods so `.trim()` does not throw at runtime.
 */
export function asTrimmedId(value: unknown): string | undefined {
  if (typeof value !== 'string' && typeof value !== 'number') return undefined
  if (typeof value === 'number' && !Number.isFinite(value)) return undefined
  const trimmed = String(value).trim()
  return trimmed || undefined
}
